<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-icon color="white" v-on="on"
        >mdi-filter{{ selected.length ? '' : '-outline' }}</v-icon
      >
    </template>
    <v-card width="185px">
      <v-list class="blackFont--text sort-choice">
        <v-list-item
          @click="ascSort"
          :title="
            columnType
              ? 'Smallest to Largest'
              : isDate
              ? 'Oldest to Newest'
              : 'A to Z'
          "
        >
          <v-list-item-title
            ><img src="@/assets/images/icon/asc.png" /><span
              class="blackFont--text font-weight-medium"
            >
              Sort
              {{
                columnType
                  ? 'Smallest to Largest'
                  : isDate
                  ? 'Oldest to Newest'
                  : 'A to Z'
              }}
            </span></v-list-item-title
          >
        </v-list-item>
        <v-list-item
          @click="descSort"
          :title="
            columnType
              ? 'Largest to Smallest'
              : isDate
              ? 'Newest to Oldest'
              : 'Z to A'
          "
        >
          <v-list-item-title
            ><img src="@/assets/images/icon/desc.png" /><span
              class="blackFont--text font-weight-medium"
            >
              Sort
              {{
                columnType
                  ? 'Largest to Smallest'
                  : isDate
                  ? 'Newest to Oldest'
                  : 'Z to A'
              }}
            </span></v-list-item-title
          >
        </v-list-item>
        <v-flex xs12 class="px-3 py-2">
          <v-text-field
            outlined
            single-line
            rounded
            v-model="search"
            hide-details
            placeholder="Search"
            prepend-inner-icon="search"
            class="py-0 dashSearch mb-2 text-field-sm"
          ></v-text-field>
          <VuePerfectScrollbar
            class="drawer-menu--scroll-filter"
            :settings="scrollSettings"
          >
            <template v-for="(list, index) in listFilteredItems">
              <v-checkbox
                v-if="list !== 'null' && list !== '0'"
                v-model="selected"
                :label="labelCheckbox(list)"
                :value="list"
                hide-details
                :key="index"
                :class="
                  field === 'status'
                    ? 'text-uppercase filter-checkbox filter-ceklis pa-0 mt-2'
                    : 'filter-checkbox filter-ceklis pa-0 mt-2'
                "
              ></v-checkbox>
            </template>
          </VuePerfectScrollbar>
          <v-row v-if="listFilter.length === 1 && listFilter[0] === '0'">
          </v-row>
          <v-row class="px-3" v-else>
            <!-- <v-row class="px-3"> -->
            <v-flex xs12 class="pa-0">
              <hr class="hr-line" />
            </v-flex>
            <v-btn
              small
              color="primary"
              class="mr-2 fs-12 px-4"
              @click="filtered('submit')"
              >Filter</v-btn
            >
            <v-btn small outlined class="fs-12 px-4" @click="filtered('clear')"
              >Reset</v-btn
            >
          </v-row>
        </v-flex>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { formatDate } from '@/utils/helpers';
export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    field: {
      type: String,
      required: true
    },
    columnType: {
      type: Boolean,
      required: false
    },
    listFilter: {
      type: Array,
      required: false
    },
    isCode: {
      type: Boolean,
      default: false
    },
    isDate: {
      type: Boolean,
      default: false
    },
    selectedValues: {
      type: Array,
      default: () => []
    },
    date: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: '',
      timeout: null,
      selected: [],
      scrollSettings: {
        maxScrollbarLength: 260
      }
    };
  },
  mounted() {
    this.selected = [];
  },
  computed: {
    listFilteredItems() {
      if (this.date) {
        return this.listFilter.map(val => formatDate(val));
      }
      return this.listFilter;
    }
  },
  // mounted() {
  //   console.log('list filtered', this.listFilter);
  // },
  watch: {
    selectedValues: {
      immediate: true,
      handler(val) {
        this.selected = val;
      }
    },
    search(val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit('searchColumn', {
          fieldName: this.field,
          value: val
        });
      }, 900);
    }
  },
  methods: {
    ascSort() {
      this.$emit('sortAsc', {
        fieldName: this.field
      });
      this.selected = [];
      // this.filtered('clear');
    },
    descSort() {
      this.$emit('sortAsc', {
        fieldName: '-' + this.field
      });
      this.selected = [];
      // this.filtered('clear');
    },
    filtered(type) {
      this.selected = type === 'clear' ? [] : this.selected;
      this.search = '';
      // this.$emit('filterItem', {
      //   fieldName: this.field,
      //   value: type === 'submit' ? this.selected : '',
      // });
      this.$emit('searchColumn', {
        fieldName: this.field,
        value: type === 'submit' ? this.selected : ''
      });
    },
    labelCheckbox(list) {
      if (list === 'ADHOC') {
        return 'AD HOC';
      } else if (!this.isCode) {
        return this.idrFilter(list);
      } else {
        return list;
      }
    }
  }
};
</script>
<style>
.v-list-item {
  min-height: 30px !important;
}

.filter-checkbox.v-input--selection-controls .v-input__slot > .v-label {
  color: #333 !important;
}

.filter-ceklis,
.v-text-field.text-field-sm input,
.text-field-sm .v-label {
  font-size: 12px !important;
}

.drawer-menu--scroll-filter {
  max-height: 100px;
  overflow: auto;
}
</style>
